import {
    Component, OnInit, Input, AfterViewInit, Output, EventEmitter,
    OnChanges
} from '@angular/core';
import {Question} from "./question";
import { ApiService } from "../api.service";
import {CommonService} from '../common.service';

declare var $ :any;
declare var Stack: any;

@Component({
    selector: 'app-question',
    templateUrl: './question.component.html',
    styleUrls: ['./question.component.css',]
})
export class QuestionComponent implements OnInit, AfterViewInit, OnChanges {
    @Input() question: Question;
    @Input() canSlideLeft: boolean;
    @Input() canSlideRight: boolean;
    @Input() autoSlideNext: boolean;
    @Input() clickable: boolean;
    @Output() onAnswer = new EventEmitter<number>();
    @Output() onSlide = new EventEmitter<number>();
    @Output() outPutClickAble = new EventEmitter<boolean>();
    @Input() abilityTest:boolean;

    initialized: boolean;
    cardItems: any;

    krisna: any;
    firstTotast: boolean;
  assetsRoute: string = "../../assets";

    constructor(private apiService: ApiService,private commonService: CommonService) {}

    ngOnInit() {
      this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
      this.initialized = true;
      this.cardItems = [1, 2, 3];


      let cid = 0, type = 13;
      this.apiService.ajax({
        'type': 'GET',
        'url': '/sr/incentiveLine/firstHints/'+cid+'/'+type,
        'data': {}
      }).subscribe(result =>{
        this.firstTotast = result.firstFlag;
      });
    }


    ngOnChanges() {
      if (this.initialized) {
        this.changeSelectedItemColor();
      }
    }

  closeTotast(){
      $('.firstTotast').hide();
  }


  onClickOption(index: number): void {
    if(this.clickable){
      var that = this;
      this.clickable = false;
      for (var i = 0; i< this.question.options.length; i++)
      {
        this.question.options[i].selected = false;
      }
      this.question.options[index].selected = true;
      this.changeSelectedItemColor();
      setTimeout(function () {
        that.onAnswer.emit(index + 1);
        setTimeout(function(){
          if (that.autoSlideNext) {
              that.krisna.reject();
          }
        }, 500);
      }, 250);

      setTimeout(()=>{
        that.outPutClickAble.emit(true);
      },1000);
    }
  }

  changeSelectedItemColor(): void {
    var index = this.question.options.length;
    for (var i = 0; i < this.question.options.length; i++){
      if (this.question.options[i].selected){
        index = i;
        break;
      }
    }
    $(".demoOut path").css({ fill: "#ffffff" });
    $(".demoOut text").css({ fill: "#4a4a4a" });

    $(".card").find("path:eq(" + index + ")").css({ fill: "#7296e6" });
    $(".card").find("text:eq(" + index + ")").css({ fill: "#ffffff" });
  }

  ngAfterViewInit() {

    if(this.abilityTest){
      $(".cards").css({
          "top": "3.6rem"
      });
    }

    $(".bgPic").each(function (index) {
      var randomNum=Math.random()*100;
      if(randomNum>=0&&randomNum<20){
        $(this).css({backgroundImage:'url("../../assets/picture/feature/bg1.svg")'});
      }else if(randomNum>=20&&randomNum<40 ){
        $(this).css({backgroundImage:'url("../../assets/picture/feature/bg2.svg")'});
      } else if(randomNum>=40&&randomNum<60 ){
        $(this).css({backgroundImage:'url("../../assets/picture/feature/bg3.svg")'});
      } else if(randomNum>=60&&randomNum<80 ){
        $(this).css({backgroundImage:'url("../../assets/picture/feature/bg4.svg")'});
      }else{
        $(this).css({backgroundImage:'url("../../assets/picture/feature/bg5.svg")'});
      }
    });

    this.initSlideEvent();
    this.changeSelectedItemColor();

    this.krisna = new Stack(document.getElementById('cards'));

  }

  initSlideEvent() {
    var startX,startY;
    var moveEndX,moveEndY;
    var X,Y;
    var onSlide = this.onSlide;

    var that = this;

    $("#cards").on("touchstart", function(e) {
      startX = e.originalEvent.changedTouches[0].pageX;
      startY = e.originalEvent.changedTouches[0].pageY;
    });
    $("#cards").on("touchmove", function(e) {
      moveEndX = e.originalEvent.changedTouches[0].pageX;
      moveEndY = e.originalEvent.changedTouches[0].pageY;
      X = moveEndX - startX;
      Y = moveEndY - startY;

      var w = X < 0? X * -1 : X;     //x轴的滑动值
      var h = Y < 0 ? Y * -1 : Y;    //y轴的滑动值
      if(w > h){                   //如果是在x轴中滑动
          event.preventDefault();
      }
    });
    $("#cards").on("touchend", function(e) {
      moveEndX = e.originalEvent.changedTouches[0].pageX;
      moveEndY = e.originalEvent.changedTouches[0].pageY;
      X = moveEndX - startX;
      Y = moveEndY - startY;

      var w = X < 0? X * -1 : X;     //x轴的滑动值
      var h = Y < 0 ? Y * -1 : Y;    //y轴的滑动值
      // if(w > h){                   //如果是在x轴中滑动
      //   // event.preventDefault();
      // }
      if(X > 5 && that.canSlideRight && w > h) {
        onSlide.emit(1);
        that.krisna.accept();
      }
      else if ( X < -5 && that.canSlideLeft && w > h) {
        onSlide.emit(-1);
        that.krisna.reject();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/question/question.component.ts